module.exports = __webpack_public_path__ + "img/vid_iFund.fa54c6e8.jpg";